import { useApi } from '@hero/context';

import type { UseTransactionApi, UseTransactionListApi, UseTransactionOrdersApi } from './types';
import { useInfiniteQueryAPI, useQueryAPI } from '../../utils';

/**
 * Get a single transaction by ID.
 *
 * Hook API: {@link UseTransactionApi}
 */
export const useTransactionApi: UseTransactionApi = (id, apiConfig) => {
  const api = useApi();
  return useQueryAPI({
    entity: 'transaction',
    apiFn: api.payment.getTransaction,
    query: undefined,
    singleIdQuery: id,
    apiConfig,
    isEnabled: () => !!id,
  });
};

/**
 * List current user transactions with pagination and optional category/status/invoiceId filter.
 * API from ApiProvider (useApi()); works in any app without overrides.
 *
 * Hook API: {@link UseTransactionListApi}
 */
export const useTransactionListApi: UseTransactionListApi = (query, apiConfig) => {
  const api = useApi();
  return useInfiniteQueryAPI({
    entity: 'transaction',
    apiFn: api.payment.getCurrentUserTransactions,
    query,
    apiConfig,
  });
};

/**
 * List orders linked to a specific transaction with pagination.
 * API from ApiProvider (useApi()); works in any app without overrides.
 *
 * Hook API: {@link UseTransactionOrdersApi}
 */
export const useTransactionOrdersApi: UseTransactionOrdersApi = (query, apiConfig) => {
  const api = useApi();
  return useInfiniteQueryAPI({
    entity: 'transaction',
    apiFn: api.payment.getTransactionOrders,
    query,
    apiConfig,
  });
};
